/**
 * `trackBy` por id para las listas que vienen de Firestore.
 *
 * Sin `trackBy`, cada emision de un listener le da a `*ngFor` un arreglo con objetos
 * nuevos —aunque el contenido sea identico— y Angular destruye y vuelve a crear **todas**
 * las filas. En la pantalla de pedidos eso pasa con cada cambio de estado de cualquier
 * pedido, y en el chat con cada mensaje: se pierde el foco, el scroll salta y las
 * imagenes de cada tarjeta se vuelven a pedir.
 *
 * Todos los documentos de este repo llevan `id`, que se le pega en el punto de lectura.
 * El indice es el respaldo para lo que no lo tenga.
 */
export function trackById(index: number, item: { id?: string } | undefined): string | number {
  return item && item.id !== undefined ? item.id : index;
}

/** `trackBy` por indice, para listas de valores sin identidad propia. */
export function trackByIndex(index: number): number {
  return index;
}
